import { Link, List, Stack, Text } from "basis";

export const DirectDebit = () => (
  <Stack gap="4">
    <Text>
      The easiest (and quickest) way to pay off your credit card is with a
      monthly direct debit.
    </Text>
    <List>
      <List.Item>
        You can choose whether to pay a set amount, the monthly minimum, or the
        full closing balance.
      </List.Item>
      <List.Item>
        On your due date each month, your payment will automatically happen.
      </List.Item>
      <List.Item>
        You can set up and manage your direct debit in either the Latitude app
        or{" "}
        <Link href="/direct-debit" newTab={false}>
          here in the Service Centre
        </Link>
        .
      </List.Item>
    </List>
    <Text>
      Remember that if you only make the minimum payment each month, you will
      pay more interest, and it will take you longer to pay any outstanding
      balance.
    </Text>
  </Stack>
);
